export default __webpack_public_path__ + "static/media/rejectIcon.a0432413.svg";